import React, { Component } from "react";
import "./settings.scss";
import SettingsWrapper from "../../components/Settings/SettingsWrapper";
import translator from "../../utils/translator";

class Settings extends Component {
	render() {
		let main = (
			<>
				<p style={{fontSize: "1.5em", opacity: 0.5}}>
					{translator("Project Setup", "project_settings_welcome_message")} <br />
					{translator("Project Setup", "project_settings_welcome_submessage")}
				</p>
			</>
		);
		return (
			<SettingsWrapper header={translator("Project Setup", "page_title")} main={main} />
		);
	}
}

export default Settings;
